export default function StatsBar() {
  const stats = [
    { value: '99.8%', label: 'Accuracy rate', sub: 'in fulfilling orders' },
    { value: '24hr', label: 'Order processing', sub: 'same-day shipping available' },
    { value: '1-3 Day', label: 'Nationwide delivery', sub: 'to any US address' },
    { value: '100%', label: 'Transparent pricing', sub: 'no hidden fees, ever' },
  ];

  return (
    <section data-testid="stats-bar" className="bg-[#191E29] py-12 sm:py-16 lg:py-20 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-0">
          {stats.map((s, i) => (
            <div key={s.value} className={`text-center ${i > 0 ? 'lg:border-l lg:border-white/10' : ''}`}>
              <div className="font-mono-data text-3xl sm:text-4xl lg:text-5xl font-bold text-[#07c28e] mb-2">{s.value}</div>
              <p className="text-sm font-semibold text-white">{s.label}</p>
              <p className="text-xs text-white/30 mt-0.5">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
